import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12 20q-.825 0-1.412-.587Q10 18.825 10 18q0-.825.588-1.413Q11.175 16 12 16t1.413.587Q14 17.175 14 18q0 .825-.587 1.413Q12.825 20 12 20Zm0-6q-.825 0-1.412-.588Q10 12.825 10 12t.588-1.413Q11.175 10 12 10t1.413.587Q14 11.175 14 12q0 .825-.587 1.412Q12.825 14 12 14Zm0-6q-.825 0-1.412-.588Q10 6.825 10 6t.588-1.412Q11.175 4 12 4t1.413.588Q14 5.175 14 6t-.587 1.412Q12.825 8 12 8Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "flex cursor-pointer items-center justify-between rounded-md py-0.5 pl-3 hover:bg-lightgray" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-dark" }, "Development", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_toggle = _resolveComponent("vue-toggle")!
  const _component_dropdown_wrapper = _resolveComponent("dropdown-wrapper")!
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      class: "cursor-pointer fill-darkgrey hover:fill-primary",
      height: "24",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
    }, _hoisted_3)),
    _createVNode(_component_dropdown_wrapper, { "is-dropdown-opened": _ctx.isMoreOptionsDropdownOpened }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_vue_toggle, {
              "active-color": '#007cc1',
              title: '',
              toggled: _ctx.moduleToggleStore.isDevelopment,
              name: "ParkingManager",
              onToggle: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moduleToggleStore.toggleDevelopment()))
            }, null, 8, ["toggled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["is-dropdown-opened"])
  ])), [
    [_directive_click_away, _ctx.isMoreOptionsDropdownOpened && _ctx.toggleDropdown]
  ])
}